import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LOGO_ICON_WHITE, LOGO_TEXT_WHITE } from "../../data/site";

const EASE = [0.22, 1, 0.36, 1];

export const Loader = () => {
  const [ready, setReady] = useState(false);
  const [done, setDone] = useState(false);

  // Görseller animasyondan önce yüklensin — bina ikonu geç kalıp takılmasın
  useEffect(() => {
    const sources = [LOGO_ICON_WHITE, LOGO_TEXT_WHITE];
    let loaded = 0;
    const onSettled = () => {
      loaded += 1;
      if (loaded >= sources.length) setReady(true);
    };
    sources.forEach((src) => {
      const img = new Image();
      img.onload = onSettled;
      img.onerror = onSettled;
      img.src = src;
    });
    const failsafe = setTimeout(() => setReady(true), 2500);
    return () => clearTimeout(failsafe);
  }, []);

  // Akış: giriş animasyonu bittikten sonra tüm panel logolarla birlikte yukarı kayar
  useEffect(() => {
    if (!ready) return;
    const t = setTimeout(() => setDone(true), 1900);
    return () => clearTimeout(t);
  }, [ready]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="page-loader"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-ink-950"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: EASE }}
        >
          <motion.div
            exit={{ y: -120 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="flex items-center gap-5 sm:gap-7"
          >
            <motion.img
              src={LOGO_ICON_WHITE}
              alt="Yalı Yurt"
              initial={{ opacity: 0, scale: 0.6 }}
              animate={ready ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, ease: EASE }}
              className="h-16 w-auto sm:h-24"
            />
            <motion.span
              initial={{ scaleY: 0 }}
              animate={ready ? { scaleY: 1 } : {}}
              transition={{ duration: 0.5, delay: 0.45, ease: EASE }}
              className="block h-16 w-px origin-top bg-cream-50/50 sm:h-24"
            />
            <div className="overflow-hidden">
              <motion.img
                src={LOGO_TEXT_WHITE}
                alt="Yalı — Erkek Öğrenci Yurdu"
                initial={{ x: "104%" }}
                animate={ready ? { x: "0%" } : {}}
                transition={{ duration: 0.7, delay: 0.7, ease: EASE }}
                className="h-16 w-auto sm:h-24"
              />
            </div>
          </motion.div>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={ready ? { scaleX: 1 } : {}}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.1, ease: "easeInOut", delay: 0.35 }}
            className="absolute bottom-[18%] h-px w-28 origin-left bg-cream-50/30"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
